<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      ref="singleTable"
      :data="users"
      highlight-current-row
      v-loading="listLoading"
      @selection-change="selsChange"
      @current-change="selectCurrentRow"
      row-key="id"
      border
      lazy
      :load="load"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      style="width: 100%;"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column type="index" width="80"></el-table-column>
      <el-table-column label="菜单/按钮" width="200" sortable>
        <template slot-scope="scope">
          <i class="fa" :class="scope.row.icon"></i>

          {{scope.row.name}}
        </template>
      </el-table-column>
      <el-table-column prop="code" label="路由地址" width sortable></el-table-column>
      <el-table-column prop="moduleName" label="API接口" width sortable></el-table-column>
      <el-table-column prop="isPublic" label="公开" width="100" sortable>
        <template slot-scope="scope">
          <el-tag
            :type="!scope.row.isPublic  ? 'success' : 'danger'"
            disable-transitions
          >{{!scope.row.isPublic ? "否":"是"}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="orderSort" label="Sort" width="80" sortable></el-table-column>
      <el-table-column prop="isButton" label="是否按钮" width="120" sortable>
        <template slot-scope="scope">
          <el-tag
            :type="!scope.row.isButton  ? 'success' : 'danger'"
            disable-transitions
          >{{!scope.row.isButton ? "否":"是"}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="func" label="按钮事件" width sortable></el-table-column>
      <el-table-column prop="isHide" label="是否隐藏" width="120" sortable>
        <template slot-scope="scope">
          <el-tag
            :type="!scope.row.isHide  ? 'success' : 'danger'"
            disable-transitions
          >{{!scope.row.isHide ? "否":"是"}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="iskeepAlive" label="keepAlive" width="120" sortable>
        <template slot-scope="scope">
          <el-tag
            :type="!scope.row.iskeepAlive  ? 'success' : 'danger'"
            disable-transitions
          >{{!scope.row.iskeepAlive ? "否":"是"}}</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="150">
                <template scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="danger" size="mini" @click="handleDel(scope.$index, scope.row)">删除</el-button>
                </template>
      </el-table-column> -->
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-form-item label="菜单名称" prop="name">
          <el-input v-model="editForm.name" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="路由地址" prop="code">
          <el-tooltip placement="top">
            <div slot="content">
              如果是目录，请填‘-’字符
              <br />如果是按钮，请输入空格即可
              <br />如果是外链，请带上协议，比如 https://www.baidu.com
              <br />
            </div>
            <el-input v-model="editForm.code" auto-complete="off"></el-input>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="editForm.description" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Icon" prop="icon">
          <el-input v-model="editForm.icon" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="enabled">
          <el-select v-model="editForm.enabled" placeholder="请选择状态">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="排序" prop="orderSort">
          <el-input-number v-model="editForm.orderSort" :min="0" :max="200" auto-complete="off" ></el-input-number>
        </el-form-item>
        <el-form-item prop="isButton" label="是否按钮" width sortable>
          <el-switch v-model="editForm.isButton"></el-switch>
        </el-form-item>
        <el-form-item label="按钮事件" prop="func">
          <el-tooltip
            class="item"
            effect="dark"
            content="只写方法名即可，不用带括号，比如：handleEdit"
            placement="top-start"
          >
            <el-input v-model="editForm.func" auto-complete="off"></el-input>
          </el-tooltip>
        </el-form-item>
        <el-form-item prop="isPublic" label="是否公开" width sortable>
          <el-switch v-model="editForm.isPublic"></el-switch>
        </el-form-item>
        <el-form-item prop="isHide" label="隐藏菜单" width sortable>
          <el-switch v-model="editForm.isHide"></el-switch>
        </el-form-item>
        <el-form-item prop="iskeepAlive" label="keepAlive" width sortable>
          <el-switch v-model="editForm.iskeepAlive"></el-switch>
        </el-form-item>
        <el-form-item prop="pidArr" label="父级菜单" width sortable>
          <el-cascader
            :key="isResouceShow"
            placeholder="请选择，支持搜索功能"
            style="width: 400px"
            v-model="editForm.pidArr"
            :options="options"
            filterable
            change-on-select
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="moduleId" label="API接口" width sortable>
          <el-select style="width: 100%;" v-model="editForm.moduleId" filterable placeholder="请选择API">
            <el-option :key="0" :value="0" :label="'无需api'"></el-option>
            <el-option
              v-for="item in modules"
              :key="item.id"
              :value="item.id"
              :label="item.linkUrl"
            >
              <span style="float: left">{{ item.linkUrl }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-form-item label="菜单名称" prop="name">
          <el-input v-model="addForm.name" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="菜单类型">
          <el-radio-group @change="clkType" v-model="addForm.menuType">
            <el-radio label="目录"></el-radio>
            <el-radio label="页面"></el-radio>
            <el-radio label="按钮"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="路由地址" prop="code">
          <el-tooltip placement="top">
            <div slot="content">
              如果是目录，请填‘-’字符
              <br />如果是按钮，请输入空格即可
              <br />如果是外链，请带上协议，比如 https://www.baidu.com
              <br />
            </div>
            <el-input v-model="addForm.code" auto-complete="off"></el-input>
          </el-tooltip>

        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="addForm.description" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="enabled">
          <el-select v-model="addForm.enabled" placeholder="请选择状态">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="orderSort">
          <el-input-number v-model="addForm.orderSort" :min="0" :max="200" auto-complete="off"></el-input-number>
        </el-form-item>
        <el-form-item prop="isButton" label="是否按钮" width sortable>
          <el-switch v-model="addForm.isButton"></el-switch>
        </el-form-item>
        <el-form-item label="按钮事件" prop="func">
          <el-input v-model="addForm.func" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="isPublic" label="是否公开" width sortable>
          <el-switch v-model="addForm.isPublic"></el-switch>
        </el-form-item>
        <el-form-item prop="isHide" label="隐藏菜单" width sortable>
          <el-switch v-model="addForm.isHide"></el-switch>
        </el-form-item>
        <el-form-item prop="iskeepAlive" label="keepAlive" width sortable>
          <el-switch v-model="addForm.iskeepAlive"></el-switch>
        </el-form-item>
        <el-form-item prop="pidArr" label="父级菜单" width sortable>
          <el-cascader
            style="width: 400px"
            :key="isResouceShow"
            v-model="addForm.pidArr"
            :options="options"
            filterable
            change-on-select
          ></el-cascader>
        </el-form-item>

        <el-form-item prop="moduleId" label="API接口" width sortable>
          <el-select style="width: 100%;" v-model="addForm.moduleId" filterable placeholder="请选择API">
            <el-option :key="0" :value="0" :label="'无需api'"></el-option>
            <el-option
              v-for="item in modules"
              :key="item.id"
              :value="item.id"
              :label="item.linkUrl"
            >
              <span style="float: left">{{ item.linkUrl }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  getPermissionListPage,
  getPermissionTreeTable,
  removePermission,
  editPermission,
  addPermission,
  getPermissionTree,
  getModuleListPage
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      maps: new Map(),
      buttonList: [],
      tableHeight: 0, // 表格高度
      currentRow: null,
      options: [],
      isResouceShow:0, // 绑定key值
      filters: {
        name: ""
      },
      users: [],
      modules: [], //接口api列表
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false }
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        name: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入路由地址", trigger: "blur" }]
      },
      //编辑界面数据
      editForm: {
        id: 0,
        moduleId: 0,
        orderSort: 0,
        pidArr: [],
        createBy: "",
        name: "",
        code: "",
        description: "",
        icon: "",
        func: "",
        enabled: true,
        isPublic: true,
        isButton: false,
        isHide: false,
        iskeepAlive: false
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入路由地址", trigger: "blur" }]
      },
      //新增界面数据
      addForm: {
        createBy: "",
        createId: "",
        pidArr: [],
        moduleId: 0,
        orderSort: 0,
        name: "",
        code: "",
        description: "",
        icon: "",
        func: "",
        enabled: true,
        isPublic: true,
        isButton: false,
        isHide: false,
        iskeepAlive: false
      }
    };
  },
  watch:{
    options:{
      handler(v1, v2) {
        ++this.isResouceShow 
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    clkType() {
      this.addForm.isButton = false;
      if (this.addForm.menuType == "页面") {
        this.addForm.code = "";
      } else if (this.addForm.menuType == "目录") {
        this.addForm.code = "-";
      } else if (this.addForm.menuType == "按钮") {
        this.addForm.code = " ";
        this.addForm.isButton = true;
      }
    },
    callFunction(item) {
      this.filters = {
        name: item.search
      };
      this[item.func].apply(this, item);
    },
    //性别显示转换
    formatEnabled: function(row, column) {
      return row.enabled ? "正常" : "未知";
    },
    formatCreateTime: function(row, column) {
      return !row.createTime || row.createTime == ""
        ? ""
        : util.formatDate.format(new Date(row.createTime), "yyyy-MM-dd");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getPermissions();
    },
    load(tree, treeNode, resolve) {
      this.maps.set(tree.id, { tree, treeNode, resolve })
      let para = {
        page: this.page,
        f: tree.id,
        key: this.filters.name
      };
      getPermissionTreeTable(para).then(res => {
        resolve(res.data.response);
      });
    },
    refresh(parentId) {
      // 根据父级id取出对应节点数据
      const { tree, treeNode, resolve } = this.maps.get(parentId)
      this.$set(this.$refs.singleTable.store.states.lazyTreeNodeMap, parentId, [])
      if (tree) {
        this.load(tree, treeNode, resolve)
      }
    },
    //获取列表
    getPermissions() {
      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;

      //NProgress.start();
      getPermissionTreeTable(para).then(res => {
        this.users = res.data.response;
        this.listLoading = false;
        this.$refs.singleTable.setCurrentRow();
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removePermission(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getPermissions();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }
      let that = this;
      that.editLoading = true;
      ++this.isResouceShow
      this.editFormVisible = true;
      this.editForm = {};

      //this.options = [];
      let para = { pid: row.id };
      getPermissionTree(para).then(res => {
        this.options.push(res.data.response);
        that.editForm = Object.assign({}, row);
        that.editLoading = false;
      });
    },
    //显示新增界面
    handleAdd() {
      this.options = [];
      this.addFormVisible = true;
      this.addForm = {
        createBy: "",
        createId: "",
        pidArr: [],
        moduleId: 0,
        name: "",
        code: "",
        orderSort: 0,
        description: "",
        enabled: true,
        icon: "",
        isButton: false,
        isHide: false,
        iskeepAlive: false
      };

      let para = { pId: 0 };
      getPermissionTree(para).then(res => {
        this.options.push(res.data.response);
      });
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            para.modifyTime = util.formatDate.format(new Date(), "yyyy-MM-dd");

            para.pId = para.pidArr.pop();

            if (para.id == para.pId) {
              this.$message({
                message: "警告，父节点不能是自己！",
                type: "error"
              });

              this.editLoading = false;
              return;
            }
            try{
              editPermission(para).then(res => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                this.editLoading = false;
                if (res.data.success) {
                  this.editLoading = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success"
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.getPermissions();
                  if(para.pId){
                    this.refresh(para.pId)
                  }
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error"
                  });
                }
              });
            }catch{}
          });
        }
      });
    },
    //新增
    addSubmit: function() {
      let _this = this;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            para.createTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
            para.modifyTime = para.createTime;
            para.isDeleted = false;

            para.pId = para.pidArr.pop();

            var user = JSON.parse(window.localStorage.user);

            if (user && user.id > 0) {
              para.createId = user.id;
              para.createBy = user.realName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }
            
            addPermission(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              this.addLoading = false;
              if (res.data.success) {
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getPermissions();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    }
  },
  mounted() {
    this.getPermissions();

    getModuleListPage({pageSize:500}).then(res => {
      this.modules = res.data.response.pageData;
    });

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);

  }
};
</script>

<style scoped>
</style>
